import { TableProdutores } from "./components/TableProducer/TableProdutores";

export const PageProducer = () => {
  return (
    <TableProdutores />
  );
};
